import React from 'react'
import { Container, Row, Col } from 'reactstrap'
import styled from 'styled-components'
import theme from '../../theme'
import { ButtonLink, Link } from '../../common/Links'
import LogoImg from '../../../images/Logo.svg'
import { H3, Paragraph } from '../../GlobalStyles'

export const TextContainer = styled.div`
  padding: 0 20px;
  text-align: center;

  color: ${p => p.theme.colors.blueGray};
  & + & {
    margin-top: 30px;
  }
`

export const DescriptionSection = styled.div`
  padding: 70px 0;
  @media screen and (min-width: 1025px) {
    padding: 120px 0;
  }
`

export const Title = styled.h3`
  font-weight: 800;
  font-size: 24px;
  color: ${p => p.color || p.theme.colors.darkGray};
  text-align: center;
  text-transform: uppercase;
  @media screen and (min-width: 1025px) {
    font-size: 36px;
    margin-bottom: 24px;
  }
`

export const Subtitle = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 1;
  color: ${p => p.theme.colors.blueGray};
  margin: 20px 0 10px;
  @media screen and (min-width: 1025px) {
    font-size: 26px;
    margin: 20px 0;
  }
`
export const ButtonsContainer = styled.div`
  align-items: center;
  justify-content: center;
  width: 100%;
`
export const TextContainerBottom = styled.div`
  font-size: 18px;
  line-height: 1.25;
  text-align: center;
  background-color: ${p => p.color || p.theme.colors.darkGray};
  padding: 70px 0;
  color: ${p => p.color || p.theme.colors.lighterGray};
  @media screen and (min-width: 1025px) {
    font-size: 24px;
    padding: 120px 0;
  }
`

export const Logo = styled.img`
  margin-bottom: 24px;
`

export const CallToActionSection = () => {
  return (
    <div>
      <DescriptionSection>
        <Container>
          <Row>
            <TextContainer
              as={Col}
              xs='12'
              lg={{ size: 7 }}
              className='mx-auto'
            >
              <H3 color={theme.colors.navy}>Get Your Certificate Today</H3>
              <Row>
                <Paragraph
                  as={Col}
                  xs='12'
                  lg={{ size: 10, offset: 1 }}
                  marginBottom='32px'
                >
                  The training is available to you on any device: Mobile, Tablet
                  or Desktop and you're free to stop-and-go or move at your own
                  pace through the process. Based on current completion rates,
                  the training takes approximately two hours.
                </Paragraph>
              </Row>
              <Row noGutters>
                <ButtonsContainer>
                  <ButtonLink
                    url='https://pgacoach.lightspeedvt.com/'
                    bgColor={theme.colors.gold}
                    borderColor={theme.colors.gold}
                    color={theme.colors.white}
                    bgHoverColor={theme.colors.transparent}
                    borderHoverColor={theme.colors.gold}
                    hoverColor={theme.colors.gold}
                    padding='8px 64px'
                    btnStyle='secondary'
                    aria-label='Get Started Here'
                  >
                    Get Started Here
                  </ButtonLink>
                </ButtonsContainer>
              </Row>
            </TextContainer>
          </Row>
        </Container>
      </DescriptionSection>
      <TextContainerBottom>
        <Container>
          <Row>
            <TextContainer as={Col} xs='12' lg={{ size: 6, offset: 3 }}>
              <Link url='/' aria-label='PGA Coach'>
                <Logo alt='Logo' src={LogoImg} />
              </Link>
              <Paragraph color={theme.colors.white}>
                Start your journey today with PGA.Coach education, to access all
                the benefits of PGA.Coach and lay the foundation to grow sport
                participation for a lifetime.
              </Paragraph>
            </TextContainer>
          </Row>
        </Container>
      </TextContainerBottom>
    </div>
  )
}

export default CallToActionSection
